var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8045 15.9824L12.1386 22.8002C12.0766 22.8635 12.0031 22.9138 11.9222 22.9481C11.8413 22.9824 11.7545 23 11.667 23C11.5794 23 11.4926 22.9824 11.4117 22.9481C11.3308 22.9138 11.2573 22.8635 11.1953 22.8002C11.1334 22.7369 11.0843 22.6617 11.0508 22.5789C11.0173 22.4961 11 22.4074 11 22.3178C11 22.2283 11.0173 22.1395 11.0508 22.0568C11.0843 21.974 11.1334 21.8988 11.1953 21.8355L17.3905 15.5L11.1953 9.16452C11.0703 9.03659 11 8.86308 11 8.68216C11 8.50124 11.0703 8.32773 11.1953 8.1998C11.3204 8.07187 11.4901 8 11.667 8C11.8439 8 12.0135 8.07187 12.1386 8.1998L18.8045 15.0176C18.8665 15.081 18.9156 15.1561 18.9492 15.2389C18.9827 15.3217 19 15.4104 19 15.5C19 15.5896 18.9827 15.6783 18.9492 15.7611C18.9156 15.8438 18.8665 15.919 18.8045 15.9824Z",
    fill: "#B8BDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowNext);
export default __webpack_public_path__ + "static/media/icon_arrow_next.f9fd646d6f635a44d3314eae8c7b754b.svg";
export { ForwardRef as ReactComponent };